export default {
	data: {
		alerts: [],
		confirms: [],
		prompts: [],
	},

	alert: function(text, header) {
		if (!header) header = false;
		return new Promise((resolve) => {
			this.data.alerts.push({
				header: header,
				text: text,
				callback: resolve
			});
		});
	},

	confirm: function(text, header) {
		if (!header) header = "CONFIRMAR";
		return new Promise((resolve) => {
			this.data.confirms.push({
				header: header,
				text: text,
				callback: resolve
			});
		});
	},

	prompt: function(text, header, input) {
		if (!header) header = false;
		if (!input) input = {};

		let default_input = {
			type: "text",
			required: false,
			placeholder: "Digite",
		}

		for (let k in default_input) {
			if (input[k] != undefined) default_input[k] = input[k];
		}

		return new Promise((resolve) => {
			this.data.prompts.push({
				header: header,
				text: text,
				input: default_input,
				callback: resolve
			});
		});
	}
}